module.exports = __webpack_public_path__ + "img/map.65656426.png";